import { EMPTY, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { LookupGridResult, PickingResult } from '../lookup-grid-options';



 /** æ£æ¥å¸®å©è¾å¥æ¡å¼åååè¿åçæ¥è¯¢ç»æ */
function checkSearchResult(data = null) {
    if (this.searchOnServer) {
        // this._searchResult = data;
        // this.showDialog();
        this.isShow = true;
    } else {
        if (data === false) {
            this.cancelSelect();
        } else {
            this.setModelValue(this.displayText);
            this.runDictPickedEvent(null);
        }
    }
}

export function onTextChanged() {

    const self = this;

    const isPending = () => {
        return this.lookupUtils.rts.getFormState('lookup.pending');
    };

    const searchData = (e) => {

        if (this.isShow) {
            return;
        }

        if (this.isTextChange && this.displayText && (!this.nosearch || e.originalEvent) && !isPending()) {
            this.lookupUtils.pendingStart();

            this.dictPickingSubscription = this.dictPicking({
                instance: this
            }).pipe(
                switchMap((pr: PickingResult) => {
                    let o = true;
                    if (pr === undefined || pr === null) {
                        o = true;
                    }

                    if (typeof pr === 'boolean') {
                        o = pr;
                    }

                    if (typeof pr === 'object') {
                        if (pr.showDialog === undefined) {
                            o = true;
                        } else {
                            o = pr.showDialog;
                        }

                        if (pr.data) {
                            /** ä¿å­å¸®å©åä¼ éçæ°æ® */
                            this.customData = pr.data;
                        }
                    }

                    if (o) {
                        return this.httpMgr.getData(
                            {
                                search: {
                                    field: '*',
                                    value: this.displayText,
                                    type: 'equal'
                                }
                            },
                            'search'
                        );
                    } else {
                        return of({ SHOWDIALOG: o, MESSAGE:  pr.message || '' });
                    }
                })
            ).subscribe(
                (data: any) => {
                    this.closeLoading();
                    this.lookupUtils.pendingEnd();
                    if (data.hasOwnProperty('SHOWDIALOG')) {
                        if (data.SHOWDIALOG && data.MESSAGE) {
                            this.notifyService.warning(data.MESSAGE);
                        }

                        return;
                    }

                    if (data.items && data.items.length === 1 && (!data.items[0].children || !data.items[0].children.length)) {
                        let rowdata = data.items[0];
                        if (this.isTree()) {
                            const leafNode = this.treeNodeHelper.getLeafNode(rowdata);

                            let isOnlySelectLeaf = false;

                            if (!this.treeInfo) {
                                this.setTreeInfo(data);
                            }

                            if (typeof this.treeInfo.onlySelectLeaf === 'boolean' ) {
                                isOnlySelectLeaf = this.treeInfo.onlySelectLeaf;
                            } else if (typeof this.treeInfo.onlySelectLeaf === 'string') {
                                if (this.treeInfo.onlySelectLeaf === 'yes') {
                                    isOnlySelectLeaf = true;
                                } else if (this.treeInfo.onlySelectLeaf === 'no') {
                                    isOnlySelectLeaf = false;
                                } else {
                                    if (this.treeInfo.onlySelectLeaf === 'default') {
                                        isOnlySelectLeaf = data.treeInfo.onlySelectLeaf;
                                    }
                                }
                            }

                            if (isOnlySelectLeaf && !leafNode.leaf) {
                                // this.displayText = '';
                                checkSearchResult.bind(self, data)();
                                return;
                            }
                            

                            if (Array.isArray(leafNode)) {
                                checkSearchResult.bind(self, data)();
                                return;
                            } else {
                                rowdata = leafNode.data;
                            }
                        }
                        if (!this.singleSelect) {
                            rowdata = [ rowdata ];
                        }
                        this.selectItem(rowdata);

                        this.dialogClosed.emit();
                    } else {
                        checkSearchResult.bind(self, data)();
                    }
                }, (err: any) => {
                    this.closeLoading();
                    this.lookupUtils.pendingEnd();
                    let msg = err;
                    if (err.Message) {
                        msg = err.Message;
                    } else {
                        if (err.error) {
                            msg = err.error.Message || '';
                        }

                        // else {
                        //     if (typeof err === 'object' && err.name === 'TypeError' && err.stack) {
                        //         msg = err.stack || '';
                        //         const tlt = err.message || '';
                        //         this.messagerService.exception({
                        //             Code: '',
                        //             Level: '',
                        //             Message: tlt,                                  
                        //             Detail: '',
                        //             RequestId: '',
                        //             innerMessage: msg
                        //         }, { width: 500 });
                        //         return;            
                        //     }
                        // }
                    }

                    this.messagerService.error(msg);
                }
            );
        }
    };

    let inputBlurHandler = null;

    if (this.inputGroup && this.inputGroup.textbox && !this.nosearch) {
        this.lookupUtils.setActiveLookupInstance(this);
        inputBlurHandler = this.render2.listen(this.inputGroup.textbox.nativeElement, 'blur', searchData );
    }

    if (this.inputGroup) {
        this.inputGroup.enterHandle.subscribe( searchData);

        this.inputGroup.keydownHandle.subscribe((e: any) => {
            let canOpen = false;
            if (e.code === 'ArrowRight') {

                if (this.quickSelect && !this.quickSelect.enable) {
                    this.writeConsole('å¯ç¨å¿«æ·éæ©åï¼å³æ¹åé®ç¦ç¨æå¼å¸®å©', 'warn');
                    return;
                }

                if (this.editable) {
                    canOpen = !e.target.value || e.target.selectionStart === e.target.value.length;
                } else {
                    canOpen = true;
                }
            } else {
                canOpen = e.code === this.shortcutKey.open;
            }
            if (canOpen) {
                e.stopPropagation();
                e.preventDefault();
                this.showDialog();
            }
        });
    }

    return inputBlurHandler;

}
